/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Amendment_CancelledInputs */

const en_orders_amendment_cancelled = /** @type {(inputs: Orders_Amendment_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending amendment cancelled. Order restored.`)
};

const es_orders_amendment_cancelled = /** @type {(inputs: Orders_Amendment_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enmienda pendiente cancelada. Pedido restaurado.`)
};

/**
* | output |
* | --- |
* | "Pending amendment cancelled. Order restored." |
*
* @param {Orders_Amendment_CancelledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amendment_cancelled = /** @type {((inputs?: Orders_Amendment_CancelledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Amendment_CancelledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amendment_cancelled(inputs)
	return es_orders_amendment_cancelled(inputs)
});